import { render } from "./SignOut.vue?vue&type=template&id=1c1e079c&scoped=true&ts=true"
import script from "./SignOut.vue?vue&type=script&lang=ts"
export * from "./SignOut.vue?vue&type=script&lang=ts"

import "./SignOut.vue?vue&type=style&index=0&id=1c1e079c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1e079c"]])

export default __exports__